module.exports = __webpack_public_path__ + "static/media/favicon.1c755a61.ico";


//////////////////
// WEBPACK FOOTER
// ./src/favicon.ico
// module id = 149
// module chunks = 0